import { Component,NgZone, OnInit } from '@angular/core';
import {  ActivatedRoute } from '@angular/router';
@Component({
  selector: 'trvapp-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(private route: ActivatedRoute, private ngzone:NgZone) { }

  ngOnInit(): void {
    
  } 

  public onMapReady(event) {
    console.log("Map Ready")
  }
}
